<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-sheet v-if="!loading" class="py-10 py-md-13 py-lg-16" color="#FBF9F4">
        <v-container class="py-0">
          <v-row v-if="item.title" justify="center">
            <v-col cols="12" md="10" lg="9" class="item">
              <TitleWidget class="text-center"> {{ item.title }} </TitleWidget>

              <img
                v-if="item.img && item.img.featured && item.img.featured.path"
                class="d-block mt-8 mt-md-10 item-img"
                :src="files + item.img.featured.path"
                :alt="item.title"
                width="100%"
              />

              <div v-if="item.text" class="mt-8 mt-md-10 ck-content item-text">
                <span class="font-secondary" v-html="item.text"></span>
              </div>

              <div v-if="images.length > 1" class="mt-10">
                <CoolLightBox
                  :items="images"
                  :index="index"
                  @close="index = null"
                />

                <div class="images-grid-list">
                  <template v-for="(image, keyImages) in images">
                    <img
                      class="d-block cursor-pointer"
                      @click="index = keyImages"
                      :key="keyImages"
                      width="100%"
                      :src="image"
                    />
                  </template>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-alert v-else class="secondary white--text mt-10">
            <v-icon class="mb-1 mr-2" size="26" color="white">
              fa-info-circle
            </v-icon>
            <span class="font-secondary">
              Nenhum conteúdo adicionado até o momento.
            </span>
          </v-alert>
        </v-container>
      </v-sheet>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    images() {
      const images = this.item.img;

      if (images.list && images.list.length)
        return images.list.map(({ path }) => {
          return this.files + path;
        });
      return [];
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    CoolLightBox,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 16 / 9;
    -o-object-fit: contain;
    object-fit: contain;
  }

  .images-grid-list {
    display: grid;
    gap: 5px;
    grid-template-columns: repeat(4, minmax(0, 1fr));

    @media screen and (max-width: 960px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    img {
      aspect-ratio: 16 / 12;
      -o-object-fit: cover;
      object-fit: cover;
    }
  }
}
</style>
